'use client'
import { useRef } from 'react'

import BackgroundVideo from './background-video'
import GlassisMainHeader from './glassis-main-header/glassis-main-header'
import SectionContainer from './section-container'
import { TouchProvider } from './touch-context'

const GlassisMainPage = () => {
  const containerRef = useRef<HTMLDivElement>(null)

  return (
    <TouchProvider containerRef={containerRef}>
      <GlassisMainHeader containerRef={containerRef} />
      <BackgroundVideo />
      <SectionContainer containerRef={containerRef} />
    </TouchProvider>
  )
}

export default GlassisMainPage
